export default __webpack_public_path__ + "static/media/676.347677fc.gif";